<template>
  <div>
    <div class="toefl-container toefl-home">
      <div class="row">
        <div class="col-md-8 col-sm-12">
          <div class="toefl-img">
            <img style="width:100%" src="../assets/IELTS.png" alt="" />
          </div>
        </div>
        <div class="col-md-4 col-sm-12 right">
          <div class="title">
            <p>
              FREE official <br />
              IELTS&reg; mock tests.
            </p>
          </div>
          <div class="title">
            <p>Start practicing now.</p>
          </div>
          <div v-if="isLogin">
            <div class="ielts-button">
              <a href="/ielts">
                <el-button type="success" style="width:100%">
                  IELTS Mocks
                </el-button>
              </a>
            </div>
          </div>
          <div v-else>
            <div class="ielts-button">
              <a href="/login">
                <el-button type="success" style="width:100%">
                  Sign in
                </el-button>
              </a>
            </div>
            <div class="ielts-button">
              <a href="/register">
                <el-button style="width:100%">Register</el-button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- page1 -->
      <div class="row page page1 text-center">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="page-title" v-html="$t('home.page1-title')"></div>
          <div class="page-content" v-html="$t('home.page1-content1')"></div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="img">
            <img
              src="https://ivy-way-toefl.s3.ap-northeast-1.amazonaws.com/toefl/img/home/page1.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- page2 -->
      <div class="row page page2">
        <div class="col-md-6 col-xs-12">
          <div class="page-title" v-html="$t('home.page2-title')"></div>
          <div class="page-content" v-html="$t('home.page2-content1')"></div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="img">
            <img
              v-if="lang.value === 'EN-US'"
              src="https://ivy-way-toefl.s3.ap-northeast-1.amazonaws.com/toefl/img/home/page2E.png"
              alt=""
            />
            <img
              v-else
              src="https://ivy-way-toefl.s3.ap-northeast-1.amazonaws.com/toefl/img/home/page2.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- page3 -->
      <div class="row page page3">
        <div class="col-md-6 col-xs-12">
          <div class="page-title" v-html="$t('home.page3-title')"></div>
          <div class="page-content" v-html="$t('home.page3-content1')"></div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="img">
            <img
              src="https://ivy-way-toefl.s3.ap-northeast-1.amazonaws.com/toefl/img/home/page3.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- page4 -->
      <div class="row page page4">
        <div class="col-md-6 col-xs-12">
          <div class="page-title" v-html="$t('home.page4-title')"></div>
          <div class="page-content" v-html="$t('home.page4-content1')"></div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="img">
            <img
              src="https://ivy-way-toefl.s3.ap-northeast-1.amazonaws.com/toefl/img/home/page4.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- page5 -->
      <div class="row page page5">
        <div class="col-md-6 col-xs-12">
          <div class="page-title" v-html="$t('home.page5-title')"></div>
          <div class="page-content" v-html="$t('home.page5-content1')"></div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="img">
            <img
              src="https://ivy-way-toefl.s3.ap-northeast-1.amazonaws.com/toefl/img/home/page5.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- page6 -->
      <div class="row page page7" style="height:auto;min-height: auto">
        <div class="col-sm-6 col-xs-12">
          <div class="page-title">
            Start Practicing for free.
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row" style="margin:0;line-height:54px" v-if="!isLogin">
            <div class="toefl-button col-md-6">
              <router-link :to="{ name: 'Login' }" style="width:100%">
                <el-button type="success" style="width:100%">
                  Sign in
                </el-button>
              </router-link>
            </div>
            <div class="toefl-button col-md-6">
              <router-link :to="{ name: 'Register' }" style="width:100%">
                <el-button style="width:100%">Register</el-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row page page8">
        <div class="">
          <!-- <div class="text-center box-header">
            <h2 class="">
              Blog
            </h2>
          </div> -->
          <div class="row">
            <div
              class="col-sm-4"
              v-for="(passage, index) in blogList"
              :key="index"
            >
              <a :href="passage.url" class="passage-box">
                <div class="header">
                  <img alt="img" :src="passage.img" width="" />
                </div>
                <div class="footer">
                  <h4 class="title">
                    {{ passage.title }}
                  </h4>
                  <p class="passage-info">
                    {{ passage.content }}
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable no-unused-vars */
import { mapState, mapGetters, mapActions } from "vuex";
/*eslint-enable */

export default {
  metaInfo() {
    return {
      title: "Home - " + this.CompanyName
    };
  },

  mixins: [],

  props: [],
  data() {
    return {
      blogList: [
        {
          title: "雅思考試題型分析",
          content:
            "雅思測試內容涵蓋聽力、閱讀、寫作與口說四個項目，各有不同的題型與時間限制。",
          url: "https://ielts.idp.com/taiwan/prepare/article-question-types",
          img:
            "https://images.ctfassets.net/unrdeg6se4ke/2b7JrbD0wv5wxxu36ZaFvG/72d07d091e2bd8534048a51e30a04944/shutterstock_531418417.jpg?fit=fill&w=1600&h=462&fm=webp"
        },
        {
          title: "雅思",
          content:
            "雅思（英語：IELTS，發音為/ˈaɪ.ɛlts/），全稱為國際英語測試系統（International English Language Testing System），是著名的國際性英語標準化水準測試之一",
          url: "https://zh.wikipedia.org/zh-tw/%E9%9B%85%E6%80%9D",
          img:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/IELTS_logo.svg/330px-IELTS_logo.svg.png"
        },
        {
          title: "IELTS雅思準備課程",
          content: "與IELTS雅思官方考試中心的英語專家一起準備考試",
          url:
            "https://www.britishcouncil.org.tw/english/exam-preparation/ielts",
          img:
            "https://www.britishcouncil.org.tw/sites/default/files/styles/bc-landscape-800x450/public/2017_ielts-path-to-your-success-apr.png?itok=z6dXhJMj"
        },
        {
          title: "IELTS雅思介紹及技巧分析",
          content: "IELTS雅思介紹及技巧分析",
          url: "http://cal.lib.nchu.edu.tw/d.php?fileid=584",
          img:
            "https://vclass-cdn.voicetube.com/assets/img/courses/college-essays/you-will-learn.webp"
        },
        {
          title: "雅思簡介及高分技巧",
          content: "雅思簡介及高分技巧！",
          url: "http://www.lanyang.tku.edu.tw/zh_tw/news/iitnews/%E9%9B%85%E6%80%9D%E7%B0%A1%E4%BB%8B%E5%8F%8A%E9%AB%98%E5%88%86%E6%8A%80%E5%B7%A7-79123359",
          img:
            "https://vclass-cdn.voicetube.com/assets/img/courses/college-essays/feature.webp"
        },

        {
          title:
            "雅思介紹分享",
          content:
            "小弟我在前幾天參加了一場雅思考試講座，覺得很有用，消化過後想向大家分享一下，學弟妹們還有時間，如果未來有打算去英國、澳洲、加拿大…等等英語系國家，可以趁還有時間，在暑假好好準備一下吧。",
          url: "https://www.dcard.tw/f/pccu/p/228976206",
          img:
            "https://imgur.dcard.tw/C35bI2Kh.png"
        }
      ]
    };
  },
  computed: {
    ...mapState("user", ["token", "lang"]),
    isLogin() {
      return this.token !== "";
    }
  },
  watch: {},

  mounted() {},

  methods: {}
};
</script>

<style scoped>
.toefl-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
}
.toefl-welcome {
  margin-bottom: 15px;
}
.toefl-home {
  padding: 20px 20px;
}
.toefl-img {
  border: 2px solid var(--themeColor);
  /* padding: 20px; */
}
.title {
  font-size: 40px;
  line-height: 55px;
  font-weight: 700;
  color: var(--themeColor);
  text-align: center;
  margin-bottom: 40px;
}
.ielts-button {
  margin: 30px 0 0 0;
  padding: 0 20px;
}
.right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (max-width: 736px) {
  .title {
    font-size: 30px;
    line-height: 30px;
    font-weight: 700;
    color: var(--themeColor);
    text-align: center;
    margin-top: 20px;
  }
}
</style>
<style scoped>
.toefl-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
}
.page-title {
  font-size: 50px;
  line-height: 65px;
  font-weight: 700;
  /* text-align: center; */
  margin-bottom: 40px;
  /* word-break: break-all !important;
  word-wrap: break-word !important; */
  width: 100%;
}
.page1 .page-title {
  margin-bottom: 20px;
}
.page-content {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 20px;
  /* word-break: break-all !important;
  word-wrap: break-word !important; */
}
.page .img {
  text-align: center;
}
.page .img img {
  max-height: 550px;
  max-width: 100%;
}
.page1,
.page3,
.page5 {
  background: #f1faf7;
}
.page6 {
  text-align: center;
}
.page6 a {
  display: block;
}
.page6 .img {
  padding: 30px;
}

.page6 .img img {
  width: 100%;
  max-height: 300px;
  border: 4px solid #efefef;
}
.page3,
.page5 {
  flex-direction: row-reverse;
}
.page7 {
  background: #ebebeb;
}
.toefl-welcome {
  /* margin-bottom: 15px; */
}
.toefl-home {
  /* padding-top: 20px; */
}
.toefl-img {
  border: 2px solid var(--themeColor);
  padding: 20px;
}

.title {
  font-size: 40px;
  line-height: 55px;
  font-weight: 700;
  color: var(--themeColor);
  text-align: center;
}
.title {
  margin-bottom: 40px;
}
.title h1 {
  font-weight: 700;
  color: var(--themeColor);
  margin-bottom: 0;
}
.toefl-button {
  margin: 30px 0 0 0;
  /* padding: 0 20px; */
}
.page .toefl-button {
  margin: auto 0;
  /* padding: 0 20px; */
}
.right {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.page8.footer {
  background-color: #f3f3f1;
  color: rgba(0, 0, 0, 0.65);
}
.page.page8 {
  min-height: auto;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.65);
}
.box-header {
  margin-bottom: 40px;
}
.passage-box {
  display: inline-block;
  text-decoration: none;
  margin: 20px 20px 0 20px;
  width: 100%;
  color: rgba(0, 0, 0, 0.43) !important;
  cursor: pointer;
  transition: all 0.3s ease 0s;
}
.passage-box:hover {
  transform: translateY(-6px);
}
.passage-box .header {
  height: 220px;
  overflow: hidden;
}
.passage-box .header img {
  display: block;
  width: 100%;
  height: 100%;
}
.footer .title {
  text-align: left;
  width: 100%;
  line-height: 1.5em;
  max-height: 68px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  margin: 10px 0;
  font-size: 24px;
}
.passage-info {
  margin: 20px 0;
  height: 200px;
}
@media screen and (min-width: 1080px) {
  .toefl-container {
    padding: 0;
  }
  .passage-box .header {
    height: 320px;
    overflow: hidden;
  }
  .page {
    padding: 40px 10%;
    /* text-align: center; */
    min-height: calc(100vh - 100px);
    border-top: 1px solid #efefef;
  }
  .page0 {
    padding: 40px 60px;
    border: none;
  }
  .page > .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    flex-direction: column;
  }
  .page7 .page-title {
    margin-bottom: 0px;
  }
}
@media screen and (max-width: 1080px) {
  .title {
    font-size: 30px;
    line-height: 30px;
    font-weight: 700;
    color: var(--themeColor);
    text-align: center;
    margin-top: 20px;
  }
  .title h1 {
    font-size: 30px;
  }
  .toefl-container {
    padding: 15px;
  }
  .toefl-button {
    margin: 30px 0 20px 0;
  }
  .title {
    margin-bottom: 0;
  }
  .page {
    padding: 40px 20px;
    border-top: 1px solid #efefef;
  }
  .page-title {
    font-size: 25px;
    line-height: 1.125;
    font-weight: 600;
    text-align: center;
    margin-bottom: 30px;
    word-break: unset !important;
  }
  .page1 .page-title {
    margin-bottom: 30px;
    text-align: center;
  }
  .page2.page .img img {
    width: 80%;
  }
  .page-content {
    font-size: 19px;
    font-weight: 400;
    line-height: 1.3;
    margin-bottom: 20px;
    word-break: unset !important;
  }
  .page .img {
    text-align: center;
    width: 100%;
  }
  .page .img img {
    height: auto;
    width: 100%;
  }
  .page5 {
    background: #f1faf7;
  }

  .page6 {
    text-align: center;
  }
  .page6 a {
    display: block;
  }
  .page6 .img {
    padding: 15px 0;
  }

  .page6 .img img {
    width: 100%;
    max-height: 300px;
    border: 4px solid #efefef;
  }
  .page3,
  .page5 {
    flex-direction: row-reverse;
  }
  .page7 {
    background: #ebebeb;
  }
}
@media screen and (max-width: 400px) {
  /* .toefl-home {
    padding: 3.2vw;
  } */
  .toefl-button {
    padding: 0;
  }
  .toefl-container {
    padding: 15px;
  }
  .toefl-container {
    padding-bottom: 0;
  }
}
</style>
